// utils/dateUtils.js
import { format } from "date-fns";

export const formatDateForDisplay = (date) => {
  if (!date) return ""; // Devuelve vacío si la fecha no está definida
  return format(new Date(date), "dd/MM/yyyy"); // Formatea la fecha para visualización
};

export const formatDateForAPI = (date) => {
  if (date === "" || date === undefined || date === null) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  return format(d, "yyyy-MM-dd");
};

/** Fecha local a mediodía para date pickers (evita saltos de día por TZ). */
export const parseMuestraDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    const d = new Date(value);
    d.setHours(12, 0, 0, 0);
    return d;
  }
  if (typeof value === "string") {
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) {
      return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12);
    }
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(12, 0, 0, 0);
  return d;
};

/** Mismo criterio que DrawerMuestra (formatDateToISO): solo día, sin ISO con hora/Z. */
export const formatMuestraDateForAPI = (value) => {
  if (value === "" || value === undefined || value === null) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  const d =
    value instanceof Date ? value : parseMuestraDate(value) || new Date(value);
  if (!d || Number.isNaN(d.getTime())) return null;
  const offset = d.getTimezoneOffset();
  const localDate = new Date(d.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split("T")[0];
};
